
// Newsletter form submit
document.querySelectorAll("[data-form-newsletter]").forEach(form => {
  const successEl = form.querySelector('[data-form-newsletter-success]');
  const errorEL = form.querySelector('[data-form-newsletter-error]');
  const loadingEl = form.querySelector('[data-form-newsletter-loading]');
  const buttonEl = form.querySelector('button');

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    loadingEl.classList.remove('hidden');
    buttonEl.classList.add("disabled")

    await fetch(e.target.action, {
      method: "POST",
      body: new FormData(e.target)
    }).then(res => res.json()).then((res) => {
      successEl.classList.remove('hidden');
      loadingEl.classList.add('hidden');
      setTimeout(() => {
        buttonEl.classList.remove("disabled");
        form.reset();
        successEl.classList.add('hidden');
      }, 7000);
    }).catch(e => {
      loadingEl.classList.add('hidden');
      form.reset();
      errorEL.classList.remove('hidden');
      buttonEl.classList.remove("disabled")
      setTimeout(() => { errorEL.classList.add('hidden')}, 7000);
    })
  })
})

// Contact form submit
document.querySelectorAll("[data-form-contact]").forEach(form => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    await fetch("https://nordit.hr", {
      method: "POST",
      body: new FormData(e.target)
    }).then(res => res.json()).then((res) => {
      console.log('res', res)
      console.log('typeof res', typeof res)
    }).catch(e => {
      console.log('e', e)
    })
  })
})

